<template>
  <div class="address-condition"></div>
</template>

<script>
export default {
  name: 'AddressCondition'
}
</script>

<style scoped></style>
